<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <cliente-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import ClienteProvider from "../../../providers/ClienteProvider";
    
    import { CrudUpdate } from '@dracul/common-frontend'
    import { ClientError } from "../../../../../errors";
    
    import ClienteForm from "../ClienteForm";
  
    

    export default {
        name: "ClienteUpdate",
        
        components: { ClienteForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'cliente.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                     id: this.item.id,
                    tipoDocumento: this.item.tipoDocumento,
                    numeroDocumento: this.item.numeroDocumento != null ? this.item.numeroDocumento : null,
                    razonSocial: this.item.razonSocial,
                    email: this.item.email,
                    telefono: this.item.telefono,
                    domicilio: this.item.domicilio,
                    piso: this.item.piso,
                    departamento: this.item.departamento,
                    codigoPostal: this.item.codigoPostal,
                    condicionIVA: this.item.condicionIVA,
                    activo: this.item.activo,
                    listaPreciosVentaDefaultId: this.item.listaPreciosVentaDefaultId || null,
                    tipoComprobanteDefault: this.item.tipoComprobanteDefault || null,
                }
            }
        },
        methods: {
            update() {
                this.$refs.form.validateThenConfirm(() => this.performUpdate())
            },
            performUpdate() {
                this.loading = true
                ClienteProvider.updateCliente(this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.clienteUpdate)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
            }
        },
    }
</script>

<style scoped>

</style>
